import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';

import {
  AbstractSecurityStorage,
  authInterceptor,
  LogLevel,
  provideAuth as provideAuthOidc,
} from 'angular-auth-oidc-client';

import { environment } from 'environments/environment';

import { AuthLocalStorageService } from './auth-local-storage.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [
    provideHttpClient(withInterceptors([authInterceptor()])),
    provideAuthOidc({
      config: {
        authority: environment.authUrl,
        redirectUrl: `${window.location.origin}/auth-callback`,
        clientId: 'cms_client',
        scope: 'openid profile email offline_access cms_api',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: `${window.location.origin}/silent-renew.html`,
        useRefreshToken: true,
        postLoginRoute: '/home',
        postLogoutRedirectUri: window.location.origin,
        forbiddenRoute: '/forbidden',
        unauthorizedRoute: '/unauthorized',
        autoUserInfo: true,
        historyCleanupOff: true,
        maxIdTokenIatOffsetAllowedInSeconds: 60,
        secureRoutes: [
          environment.billingUrl,
          environment.facilityManagementUrl,
          environment.logisticsUrl,
          environment.marketplaceUrl,
          environment.notificationsUrl,
          environment.paymentsUrl,
          environment.referenceDataUrl,
          environment.storageManagementUrl,
          environment.userManagementUrl,
        ],
      },
    }),
    {
      provide: AbstractSecurityStorage,
      useClass: AuthLocalStorageService,
    },
  ];
};
